export const DEFAULT_TIME_DISTANCE = 30;
export const SPLIT_BY_MINUTES = 15;